import { extend } from 'flarum/common/extend';
import extractText from 'flarum/common/utils/extractText';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import PostControls from 'flarum/forum/utils/PostControls';
import UserControls from 'flarum/forum/utils/UserControls';
import CommentPost from 'flarum/forum/components/CommentPost';
import Button from 'flarum/common/components/Button';
import ShareModal from './components/ShareModal';
function getCanonicalUrl(path) {
  const baseUrl = (app.forum.attribute('baseUrl') || window.location.origin).replace(/\/$/, '');
  return `${baseUrl}${path}`;
}
async function shareContent(data) {
  const title = extractText(data.title) || '';
  const url = data.url || window.location.href;

  // 1. Si el dispositivo dispone de la opción nativa de compartir (navigator.share), usarla siempre
  if (navigator.share) {
    try {
      await navigator.share({
        title,
        url
      });
    } catch (err) {
      // AbortError ocurre cuando el usuario cancela la hoja nativa de compartir
      if (err.name !== 'AbortError') {
        console.warn('navigator.share failed:', err);
      }
    }
    return;
  }

  // 2. El modal se muestra únicamente como retrocompatibilidad para dispositivos/navegadores sin soporte nativo
  app.modal.show(ShareModal, {
    title,
    url
  });
}
export default () => {
  // 1. Botón de compartir en el menú de la discusión
  extend(DiscussionControls, 'userControls', function (items, discussion) {
    const url = getCanonicalUrl(app.route.discussion(discussion));
    items.add('share', Button.component({
      icon: 'fas fa-share-alt',
      onclick: () => shareContent({
        title: discussion.title(),
        url: url
      })
    }, app.translator.trans('bizkaitarra-aurrera-pwa.forum.discussion_controls.share_button') || 'Compartir'), -1);
  });

  // 2. Botón de compartir en el pie de acciones de todos los posts
  extend(CommentPost.prototype, 'actionItems', function (items) {
    const post = this.attrs.post;
    if (!post) return;
    const discussion = post.discussion();
    const isFirstPost = post.number() === 1;
    const title = isFirstPost ? discussion ? discussion.title() : '' : app.translator.trans('bizkaitarra-aurrera-pwa.forum.post_controls.share_api.title', {
      username: post.user() ? post.user().displayName() : '',
      title: discussion ? discussion.title() : ''
    });
    const url = isFirstPost && discussion ? getCanonicalUrl(app.route.discussion(discussion)) : getCanonicalUrl(app.route.post(post));
    items.add('share', Button.component({
      className: 'Button Button--link',
      icon: 'fas fa-share-alt',
      onclick: () => shareContent({
        title: title,
        url: url
      })
    }, app.translator.trans('bizkaitarra-aurrera-pwa.forum.post_controls.share_button') || 'Compartir'), -5);
  });

  // 3. Menú de controles de cada post individual
  extend(PostControls, 'userControls', function (items, post) {
    const discussion = post.discussion();
    const url = getCanonicalUrl(app.route.post(post));
    items.add('share', Button.component({
      icon: 'fas fa-share-alt',
      onclick: () => shareContent({
        title: app.translator.trans('bizkaitarra-aurrera-pwa.forum.post_controls.share_api.title', {
          username: post.user() ? post.user().displayName() : '',
          title: discussion ? discussion.title() : ''
        }),
        url: url
      })
    }, app.translator.trans('bizkaitarra-aurrera-pwa.forum.post_controls.share_button') || 'Compartir'), 100);
  });

  // 4. Menú de controles de usuario
  extend(UserControls, 'userControls', function (items, user) {
    const url = getCanonicalUrl(app.route.user(user));
    items.add('share', Button.component({
      icon: 'fas fa-share-alt',
      onclick: () => shareContent({
        title: user.displayName(),
        url: url
      })
    }, app.translator.trans('bizkaitarra-aurrera-pwa.forum.user_controls.share_button') || 'Compartir'), 100);
  });
};